import React from 'react';
//import { useAvailability } from '~/libs/infrastructure/api/availability';

import { Header } from './components/Header';
import { Row } from './components/Row';
import { Link } from 'react-router-dom';
import { availabilityMockData } from './mockData';

const dddShareThreshold = 5;

export function AvailabilityPage() {
	//const [year, setYear] = useState(YEAR_OPTIONS[0].value);
	//const [searchInput, setSearchInput] = useState('');
	//const [submittedSearch, setSubmittedSearch] = useState<string[] | null>(null);
	//const [submittedYear, setSubmittedYear] = useState<string | null>(null);

	/*const { data, isLoading, isError, isPlaceholderData } = useAvailability(params, {
		placeholderData: availabilityMockData,
	});*/

	const displayData = availabilityMockData;
	//const isMockData = params === null || isPlaceholderData;

	return (
		<div className='w-full h-full bg-white overflow-auto'>
			<Header />

			<div className='px-10 py-4 max-w-[1260px] mx-auto space-y-4 text-gray-900 font-display'>
				<div className='max-w-3xl space-y-8'>
					<section className='space-y-4 text-gray-900'>
						<p className='leading-6'>
							<strong>Monitor Dostupnosti LP</strong> slouží k automatickému sledování dostupnosti léčivých přípravků ve
							smyslu § 39c odst. 2 písm. a) zákona č. 48/1997 Sb., o veřejném zdravotním pojištění.
						</p>
						<p className='leading-6'>
							Zadáním <strong>ATC</strong> kódu, názvu <strong>účinné látky</strong>, nebo{' '}
							<strong>názvu léčivého přípravku</strong> získáte informaci, zda byl léčivý přípravek v předchozím
							kvartálu dostupný v distribuci (<strong>&gt;5 % v DIS-13</strong>) a zda je uzavřena dohoda o nejvyšší
							ceně výrobce (<strong>DNC</strong>), nebo dohoda o úhradě (<strong>DoÚ</strong>) v aktuálním Seznamu cen a
							úhrad LP (<strong>SCAU</strong>).
						</p>
						<p className='leading-6'>
							<Link
								to='/availability/metodika/'
								className='text-cBlue-500 hover:text-blue-700 underline underline-offset-2 decoration-2'
							>
								Více se dozvíte v úplné metodice
							</Link>
						</p>
					</section>
				</div>
			</div>

			<br />
			<br />
			<br />
			<br />

			<Header />
			<div className='w-full bg-gray-100 mb-6'>
				<div className='px-10 py-4 max-w-[1260px] mx-auto'>
					{displayData.map((group) => (
						<Row key={group.id} group={group} dddShareThreshold={dddShareThreshold} />
					))}
				</div>
			</div>
		</div>
	);
}
